import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { mount, unmount } from "svelte";
import { grabfold } from "grabfold/svelte";
import { createPageTurnSound } from "grabfold/sound";
import { defaultBoardTurnTakes, defaultPageTurnTakes } from "grabfold/sounds";
import { SHEETS, describe } from "../shared/pages.js";
import Page from "./Page.svelte";

var root = $.from_html(`<div class="book"></div> <nav class="controls"><button type="button">← Previous</button> <span class="where"> </span> <button type="button">Next →</button></nav>`, 1);

export default function App($$anchor, $$props) {
	$.push($$props, true);

	const sound = createPageTurnSound({
		takes: defaultPageTurnTakes,
		boardTakes: defaultBoardTurnTakes
	});

	let where = $.state("Front cover");
	let node = $.state(void 0);

	const options = {
		sheets: SHEETS,
		covers: "hard",
		label: "A little book of colours",
		sound,
		// Each page is a component, mounted into its own element once.
		render(slot, page) {
			const component = mount(Page, { target: slot, props: { page } });

			return () => unmount(component);
		},
		onTurn: () => $.set(where, describe($.get(node).grabfold.view), true)
	};

	var fragment = root();
	var div = $.first_child(fragment);

	$.bind_this(div, ($$value) => $.set(node, $$value), () => $.get(node));
	$.action(div, ($$node, $$action_arg) => grabfold?.($$node, $$action_arg), () => options);

	var nav = $.sibling(div, 2);
	var button = $.child(nav);
	var span = $.sibling(button, 2);
	var text = $.only_child(span, true);
	var button_1 = $.sibling(span, 2);

	$.reset(nav);
	$.template_effect(() => $.set_text(text, $.get(where)));
	$.delegated('click', button, () => $.get(node).grabfold.prev());
	$.delegated('click', button_1, () => $.get(node).grabfold.next());
	$.append($$anchor, fragment);
	$.pop();
}

$.delegate(['click']);